import {Component, Input} from '@angular/core';


@Component({
  selector: 'app-my-beauty-class-list-item',
  templateUrl: 'my-beauty-class-list-item.html'
})
export class MyBeautyClassListItemComponent {
  @Input() reservation: any;
}



// WEBPACK FOOTER //
// ./src/components/my-beauty-class-list-item/my-beauty-class-list-item.ts